// http://openseadragon.github.io/docs/
import OpenSeadragon from 'openseadragon'

class ZoomImage {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$popin = document.querySelector('.js-zoom-popin')
    this.ui.$popinContent = this.ui.$popin.querySelector('.js-popin-content')
    this.ui.$popinClose = this.ui.$popin.querySelector('.js-popin-close')
  }

  bindEvents() {
    this.el.addEventListener('click', this.onClick.bind(this))
    this.ui.$popinClose.addEventListener('click', this.onClose.bind(this))
  }

  onClick(e) {
    let target = e.currentTarget
    if(!target.matches('.js-zoom-image')) return

    this.ui.$popin.classList.add(`${target.getAttribute('data-theme')}`)

    let imageUrl = target.getAttribute('data-image')
    let imageAlt = target.getAttribute('data-alt')
    let imgTag = document.createElement('img')
    imgTag.src = imageUrl
    imgTag.alt = imageAlt
    imgTag.id = 'popin-zoomed-image'

    this.ui.$popinContent.append(imgTag)

    this.ui.$popin.classList.add('is-active')
    this.trapFocus(this.ui.$popin)
    this.pinchZoom(imgTag.id)
  }
  trapFocus(container) {
    const focusableElements = container.querySelectorAll('a, button');
    window.oldFocus = document.activeElement
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    container.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          container.setAttribute('aria-hidden',"true");
          container.querySelectorAll('a, button').forEach((el) => {
            el.tabIndex = -1;
          });
          this.onClose(this.ui.$popinClose);
        }
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
    });    
    setTimeout(() => {
      firstElement.focus();
    }, 100);
  }
  pinchZoom(id) {
    const viewer = OpenSeadragon({
        id: id,
        visibilityRatio: 1.0,
        constrainDuringPan: true,
        showNavigationControl: false,
    })
  }

  onClose(e) {
    let target = e.currentTarget || e
    if (!target.matches('.js-popin-close')) return
    this.ui.$popin.classList.remove('is-active')
    if (this.ui.$popin.classList.contains('dark')) {
      this.ui.$popin.classList.remove('dark')
    }
    if (this.ui.$popin.classList.contains('light')) {
      this.ui.$popin.classList.remove('light')
    }
    if (target.parentNode.querySelector('.js-popin-content img')) {
      target.parentNode.querySelector('.js-popin-content img').remove()
    }
    window.oldFocus.focus()
    window.oldFocus = null
  }
}

export default ZoomImage
